import { useEffect, DependencyList } from 'react';

export const useListenMessage = (handleMessageListener: (event: MessageEvent) => void, deps: DependencyList) => {
  useEffect(() => {
    window.addEventListener('message', handleMessageListener);
    return () => window.removeEventListener('message', handleMessageListener);
  }, deps);
};
